import React from 'react';
import type { FC, ReactNode } from 'react';
import styles from './Layout.module.scss';

import type { AuthUser, Organization, OrganizationLimits } from '../../types/user';
import { Sidebar } from '../Sidebar/Sidebar';
import { Topbar } from '../../components/Topbar/Topbar';
import { NotificationPopups } from '../../components/NotificationPopups/NotificationPopups';

interface LayoutProps {
    title?: string;
    subtitle?: string;
    actions?: ReactNode;
    onSearch?: (query: string) => void;
    user?: AuthUser | null;
    organization?: Organization | null;
    limits?: OrganizationLimits;
    onLogout?: () => void;
    scrollable?: boolean;
    children: ReactNode;
}

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
};

const formatToday = (date: Date): string => {
    const full = date.toLocaleDateString('ru-RU', DATE_FORMAT).replace(' г.', '');
    const weekday = date.toLocaleDateString('ru-RU', { weekday: 'long' });

    return `${full} · ${weekday}`;
};

export const Layout: FC<LayoutProps> = ({
    onSearch,
    user,
    organization,
    limits,
    onLogout,
    scrollable = false,
    children,
}) => (
    <div className={styles.layout}>
        <Sidebar user={user} organization={organization} />

        <div className={styles.page}>
            <Topbar
                date={formatToday(new Date())}
                user={user}
                // organization={organization}
                limits={limits}
                onSearch={onSearch}
                onLogout={onLogout}
            />

            <NotificationPopups />

            <div className={styles.body}>
                <main className={`${styles.content} ${scrollable ? styles.contentScrollable : ''}`}>
                    {children}
                </main>
            </div>
        </div>
    </div>
);